export default __webpack_public_path__ + "static/media/logo-dark.b3abeb9f.webp";